
import { ActionReducerMap } from '@ngrx/store';
import { AppState } from './app.state';
import { mainReducer } from './main/reducers/main.reducer';
import { schedulingReducer } from './schedule/reducers/schedule.reducer';
import { paymentReducer } from './payment/reducers/payroll.reducer';
import { uiReducer } from './ui/reducers/ui.reducer';
import { spotsReducer } from './spots/reducers/spots.reducer';

export const reducers: ActionReducerMap<AppState> = {
  ui: uiReducer,
  main: mainReducer,
  schedule: schedulingReducer,
  payment: paymentReducer,
  spots: spotsReducer,
};